import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col bg-white text-black rounded-b rounded-r px-5 pb-6" }
const _hoisted_2 = { class: "flex items-start justify-between mb-1 pt-3 pb-2 font-inter font-bold" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", { class: "lg:hidden" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_6 = {
  key: 0,
  class: "w-5 h-5 -ml-1 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ⚗️ ")
const _hoisted_10 = { class: "flex flex-col lg:flex-row items-center lg:space-x-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Approve ")
const _hoisted_14 = {
  key: 0,
  class: "text-red-500 text-sm font-sans mt-1"
}
const _hoisted_15 = {
  key: 0,
  class: "transition absolute flex flex-col lg:flex-row inset-0 bg-black bg-opacity-90 items-center justify-center text-red-500 text-center text-sm px-10"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "hidden lg:block w-6 h-6 -ml-1 mr-2 mb-2 lg:mb-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  })
], -1)
const _hoisted_17 = {
  key: 0,
  class: "transition absolute flex inset-0 bg-black bg-opacity-75 items-center justify-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-8 w-8 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createTextVNode(" From " + _toDisplayString(_ctx.config.l1NetworkLabel) + " ", 1),
        _hoisted_4,
        _createTextVNode(" to " + _toDisplayString(_ctx.config.l2NetworkLabel), 1)
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (_ctx.tokens && _ctx.tokens.length && _ctx.tokens[_ctx.selectedToken].approved)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                (_ctx.tokens[_ctx.selectedToken].symbol !== 'MUST')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_9
                    ], 64)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatBalance(_ctx.tokens[_ctx.selectedToken].l1Balance)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.tokens && _ctx.tokens.length && _ctx.tokens[_ctx.selectedToken].approved)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["relative flex items-stretch w-full lg:w-1/2", [{ 'cursor-not-allowed': _ctx.tokens && _ctx.tokens.length && !_ctx.tokens[_ctx.selectedToken].approved }, { 'border-red-500': _ctx.error.length }]])
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tokenAmount) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendToL2 && _ctx.sendToL2(...args)), ["enter"])),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.error = '')),
              placeholder: "min: 0.01",
              disabled: _ctx.tokens && _ctx.tokens.length && !_ctx.tokens[_ctx.selectedToken].approved,
              type: "text",
              class: _normalizeClass(["w-full h-10 text-black px-4 border border-black border-opacity-60 border-r-0 focus:outline-none", { 'border-red-500 text-red-500': _ctx.error.length }])
            }, null, 42, _hoisted_11), [
              [_vModelText, _ctx.tokenAmount]
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["px-3 bg-gold uppercase text-sm rounded-r-sm border border-black border-opacity-60 border-l-0 focus:outline-none hover:bg-black hover:text-gold transition-colors duration-300", { 'border-red-500': _ctx.error.length }]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setMax && _ctx.setMax(...args)))
            }, " max ", 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex space-x-3 items-center", { 'w-full flex-1': _ctx.tokens && _ctx.tokens.length && _ctx.tokens[_ctx.selectedToken].approved }])
      }, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedToken) = $event)),
          class: "flex-1 h-10 text-black px-3 border border-black border-opacity-60 focus:outline-none"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: token.symbol,
              value: index
            }, _toDisplayString(token.symbol), 9, _hoisted_12))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedToken]
        ]),
        (_ctx.tokens && _ctx.tokens.length && _ctx.tokens[_ctx.selectedToken].approved)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _ctx.sendToL2,
              loading: _ctx.isSendingToL2,
              enabled: _ctx.canSendToL2,
              class: "text-sm lg:text-base lg:w-auto whitespace-nowrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Send to " + _toDisplayString(_ctx.config.l2NetworkLabel), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading", "enabled"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _ctx.approveSelectedTokenOnL1,
              loading: _ctx.isApprovingL1,
              enabled: _ctx.correctNetwork,
              class: "bg-yellow-600 border-yellow-700 hover:bg-yellow-500 hover:border-yellow-600"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick", "loading", "enabled"]))
      ], 2)
    ]),
    (_ctx.error && _ctx.error.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.correctNetwork)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" Please connect to " + _toDisplayString(_ctx.config.l1NetworkLabel), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.isApprovingL1 || _ctx.isSendingToL2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}